import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Attribute } from '../entities/schema/attribute.entity';
import { GroupAttribute } from '../entities/schema/groupattribute.entity';
import { Group } from '../entities/schema/group.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class GroupAttributeService extends ODataEntityService<GroupAttribute> {
  constructor(protected client: ODataClient) {
    super(client, 'GroupAttribute', 'entities.schema.GroupAttribute');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public attribute(entity: EntityKey<GroupAttribute>): ODataNavigationPropertyResource<Attribute> {
    return this.entity(entity).navigationProperty<Attribute>('attribute');
  }
  public group(entity: EntityKey<GroupAttribute>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public status(entity: EntityKey<GroupAttribute>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<GroupAttribute>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
